module.exports = __webpack_public_path__ + "public/files/img/excel.1b7f51ec.png";